import { removeFalsyValues } from '../../../utils';
import { UserSubProfession, UserProfession } from '../../../enums/UserProfession';
import { JobsApi } from '../clients';

/**
 * Fetches job list with business logic for param building
 *
 * @param {object} filters - Raw filter state from the hook
 * @param {string} [jobType] - Optional job type filter
 * @returns {Promise<import('../types/JobList.api').IGetJobListApiResponse>} Job list response
 */
export const getJobList = async (filters, jobType) => {
  const { dateRange, ...rest } = filters;

  const params = removeFalsyValues({
    page: rest.page,
    limit: rest.limit,
    searchText: rest.searchText,
    sortField: rest.sortField,
    sortOrder: rest.sortOrder,
    jobStatus: rest.jobStatus,
    state: rest.state,
    startDate: dateRange?.startDate,
    endDate: dateRange?.endDate,
    profession: rest.subProfession === UserSubProfession.EFDA ? UserProfession.DA : rest.profession,
    subProfession: rest.subProfession,
    specialtyRdh: rest.specialtyRdh,
    specialtyDa: rest.specialtyDa,
    workerClassification:
      rest.workerClassification !== 'all' ? rest.workerClassification : undefined,
    ram: rest.ram,
    dsoName: rest.dsoName,
    dsoManager: rest.dsoManager,
    dsoRamIds: rest.dsoRamIds,
    dsoId: rest.dsoId,
    jobType,
  });

  return JobsApi.getJobList(params);
};
